/**
 * Global CSS values
 */
import { css } from 'emotion';

// Images
import triangleRed from '../images/triangle-red.svg';

const themeDefault = {
  color: {
    highlight: 'hsl(0, 93%, 66%)',
    primary: 'hsl(213, 28%, 37%)',
    primaryDark: 'hsl(213, 31%, 20%)',
    primaryBlack: 'hsl(213, 20%, 10%)',
    secondary: 'hsl(0, 0%, 89%)',
    shadow: 'hsla(0, 0%, 4%, 0.5)',
  },
  triangle: css`
    &:before {
      background-image: url(${triangleRed});
      background-position: left top;
      background-repeat: no-repeat;
      content: ' ';
      display: inline-block;
      height: 1em;
      margin-right: 0.25em;
      width: 1em;
    }
  `,
};

export default themeDefault;
